<script lang="ts">
    import type { Page } from '~/jet/models';

    import PageComponent from '~/components/Page.svelte';
    import ErrorComponent from '~/components/Error.svelte';
    import LoadingSpinner from '@amp/web-app-components/src/components/LoadingSpinner/LoadingSpinner.svelte';
    import { beforeUpdate } from 'svelte';
    import { getPageSpeedContext } from '~/utils/perfkit';

    export let page: Promise<Page> | Page;
    export let isFirstPage: boolean;

    const pageSpeedContext = getPageSpeedContext();

    beforeUpdate(() => {
        pageSpeedContext.capturePageAppearTime();
    });

    const endRender = (page: Page) => {
        const { pageMetrics } = page;
        pageSpeedContext.capturePageData({
            pageContext: pageMetrics?.pageFields?.pageFeatureName as
                | string
                | undefined,
            pageType: pageMetrics?.pageFields?.pageType as string | undefined,
            pageId: pageMetrics?.pageFields?.pageId as string | undefined,
            isFirstPage,
        });
        return '';
    };
</script>

{#await page}
    <div data-testid="page-loading">
        <!--
            Delay showing the spinner on initial page load after app boot.
            After that, the FlowAction handler already waits 500ms before
            it changes DOM, so we only need to wait 1000ms.
        -->
        <LoadingSpinner delay={isFirstPage ? 1500 : 1000} />
    </div>
{:then page}
    <PageComponent {page} />
    {#key page}
        {endRender(page)}
    {/key}
{:catch error}
    <ErrorComponent {error} />
{/await}
